import { render } from "./ViewCandidatesList.vue?vue&type=template&id=7a50a702&scoped=true"
import script from "./ViewCandidatesList.vue?vue&type=script&lang=js"
export * from "./ViewCandidatesList.vue?vue&type=script&lang=js"

import "./ViewCandidatesList.vue?vue&type=style&index=0&id=7a50a702&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a50a702"]])

export default __exports__